import type { ReceiptTemplate } from '../schema';

export const girlScoutsTemplate: ReceiptTemplate = {
  id: 'girl-scouts',
  name: 'Girl Scouts Receipt',
  brand: 'GIRL SCOUTS',
  description: 'Girl Scout Cookies receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gs-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'GIRL SCOUTS',
        businessNameFontSize: 18,
        addressLines: ['COOKIE RECEIPT', 'TROOP #4892'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gs-scout',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'scout', label: 'Scout:', value: 'Jane Doe' },
          { id: 'order', label: 'Order #:', value: 'GS-847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'troop', label: 'Troop:', value: '#4892' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gs-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'THIN MINTS', quantity: '2', price: '6.00', sku: '' },
          { id: '2', name: 'SAMOAS', quantity: '2', price: '6.00', sku: '' },
          { id: '3', name: 'TAGALONGS', quantity: '1', price: '6.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gs-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'total', label: 'TOTAL', value: '30.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gs-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU FOR SUPPORTING\nGIRL SCOUTS!\n\nBUILDING GIRLS OF\nCOURAGE, CONFIDENCE\nAND CHARACTER', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

